import { useState } from "react";
import { useDispatch } from "react-redux";
import { Modal } from "@/components/modal/modal";
import styled from "styled-components";

import ngDeps from "@/legacy-services";
import { closeModal } from "libs/modals";
import { handleError } from "utils/handleError";
import { SkedButton } from "ui";
import { FullPageLoading } from "@/components/ui/full-page-loading";

import { ADD_USER_AVATAR_MODAL } from "../../UserModals";
import {
  useDeleteCollaborationUserAvatar,
  useUpdateCollaborationUserAvatar,
} from "../../users-queries";
import type { AppDispatch } from "types/redux-dispatch";

export const UpdateAvatar = ({ user }: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const updateAvatarMutation = useUpdateCollaborationUserAvatar();
  const deleteAvatarMutation = useDeleteCollaborationUserAvatar();
  const [isLoading, setIsLoading] = useState(false);

  const {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    mediaService,
  } = ngDeps;

  const [avatar, setAvatar] = useState(user.profileImage);
  const disabled = !avatar;

  async function handleDeleteAvatar() {
    try {
      await deleteAvatarMutation.mutateAsync({
        email: user.email,
        id: user._id,
      });
      setAvatar("");
    } catch (error) {
      handleError(
        error,
        "There was an error deleting the avatar for this user."
      );
    }
  }

  const submit = async () => {
    try {
      await updateAvatarMutation.mutateAsync({
        email: user.email,
        url: avatar,
        id: user._id,
      });
      dispatch(closeModal({ type: ADD_USER_AVATAR_MODAL }));
    } catch (error) {
      handleError(
        error,
        "There was an error updating the avatar for this user."
      );
    }
  };

  function closeAddModal() {
    dispatch(closeModal({ type: ADD_USER_AVATAR_MODAL }));
  }

  const handleAvatar = (event: any) => {
    setIsLoading(true);
    mediaService.upload([...event.target.files], {
      imageUploadFailure: (err: any) => {
        setIsLoading(false);
        handleError(err);
      },
      onMedia: function (mediaFiles: { url: any }[]) {
        const url = mediaFiles[0].url;
        setAvatar(url);
        setIsLoading(false);
      },
      isStory: false,
    });
  };

  return (
    <div>
      <Modal
        show
        onHide={closeAddModal}
        animation={false}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        bsStyle="giselle"
        bsSize="small"
      >
        {(isLoading ||
          updateAvatarMutation.isPending ||
          deleteAvatarMutation.isPending) && <FullPageLoading />}
        <form name="inviteForm" className="add-user">
          <Modal.Header closeButton onHide={closeAddModal}>
            <Modal.Title>Select Picture to upload</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <p className="mb-2">Upload Image</p>
                <label className="input-container">
                  <input
                    type="file"
                    name="file"
                    accept="image/*"
                    onChange={handleAvatar}
                  />
                  <span className="icon glyphicon glyphicon-upload"></span>
                </label>

                {avatar && (
                  <div className="del-img">
                    <div className="imag-c">
                      {avatar && (
                        <img
                          className="uploadedImg"
                          src={avatar}
                          alt="Avatar"
                        />
                      )}
                    </div>
                    <DeleteButton
                      className="delete-action"
                      onClick={handleDeleteAvatar}
                    >
                      <span className="right-icon glyphicon glyphicon-trash"></span>
                      &nbsp;Delete Current Profile Image
                    </DeleteButton>
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn-link" onClick={closeAddModal}>
              Cancel
            </button>
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore*/}
            <Submit type="primary" disabled={disabled} onClick={submit}>
              Submit
            </Submit>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};

const Submit = styled(SkedButton)`
  button {
    font-weight: normal !important;
  }
`;
const DeleteButton = styled.div`
  cursor: pointer;
  color: red;
  text-decoration: none;
  margin-left: 10px;
`;
